import React from "react";

import { Link } from "@mui/material";

import CancellationPolicyDialog from "components/CancellationPolicyDialog/CancellationPolicyDialog";
import { useCancellationPolicies } from "../hooks/useCancellationPolicies";

type CancellationPolicyLinkProps = {
  trips: { routes: { vehicle?: { id: string } }[] }[];
};

function CancellationPolicyLink(props: CancellationPolicyLinkProps) {
  const { trips } = props;

  // hooks
  const {
    cancellationPolicies,
    shouldRenderCancellationPolicies,
    cancellationPolicyDialogOpen,
    onCancellationPolicyClick,
    onCancellationPolicyClose,
  } = useCancellationPolicies({ trips });

  if (!shouldRenderCancellationPolicies) {
    return null;
  }

  return (
    <>
      <Link
        component="span"
        style={{ fontWeight: 700, cursor: "pointer" }}
        onClick={onCancellationPolicyClick}
      >
        Cancellation Policy
      </Link>
      <CancellationPolicyDialog
        cancellationPolicyOpen={cancellationPolicyDialogOpen}
        onCancellationPolicyClose={onCancellationPolicyClose}
        cancellationPolicies={cancellationPolicies}
      />
    </>
  );
}

export default CancellationPolicyLink;
